<template>
  <div class="team-video-analysis">
    <el-select
      v-model="teamId"
      size="small"
      placeholder="请选择团队"
      @change="getList"
    >
      <el-option
        v-for="item in teamList"
        :key="item.teamId"
        :label="item.name"
        :value="item.teamId"
      >
      </el-option>
    </el-select>
    <ve-histogram
      width="1134px"
      :data="teamVideoData"
      :settings="settings"
      :extend="chartExtend"
    ></ve-histogram>
  </div>
</template>

<script>
import { teamList } from "@/api/team";
import { teamVideoAnalysis } from "@/api/projectPractice/analysis";

export default {
  data() {
    return {
      teamId: 1,
      teamList: [],
      teamVideoData: {
        columns: [
          "episode",
          "playCount",
          "commentCount",
          "forwardCount",
          "downloadCount",
          "diggCount",
          "shareCount",
        ],
        rows: [],
      },
      settings: {
        stack: {
          数据: [
            "playCount",
            "commentCount",
            "forwardCount",
            "downloadCount",
            "diggCount",
            "shareCount",
          ],
        },
        labelMap: {
          playCount: "播放量",
          commentCount: "评论量",
          forwardCount: "转发量",
          downloadCount: "下载量",
          diggCount: "点赞量",
          shareCount: "分享量",
        },
      },
      chartExtend: {
        series(v) {
          v.forEach((i) => {
            i.barWidth = 60;
          });
          return v;
        },
      },
    };
  },
  created() {
    this.getTeam();
  },
  methods: {
    // 团队列表
    getTeam() {
      teamList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.teamList = res.data;
          if (this.teamList) this.teamId = this.teamList[0].teamId;

          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getList() {
      this.$loading.show();
      teamVideoAnalysis({ teamId: this.teamId }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          res.data.forEach((item) => {
            item.episode = `第${item.episode}集`;
          });
          this.teamVideoData.rows = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.team-video-analysis {
  text-align: left;
}
</style>